
gsap.registerPlugin(ScrollTrigger)

const blocksWrapper = document.querySelectorAll('[data-animation-in]');

Array.from(blocksWrapper).forEach((block, i) => {

    gsap.from(block, {
        scrollTrigger: {
            trigger: block,
            start: "top bottom",
            end: "top+=400 bottom",
            scrub: 1,
            // markers: true,
        },
        y: "200px",
        opacity: 0,
    })
});